import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { ACTION_TYPE_ADD_POINT, pointResult, pointError, epicCatchError, showRichModal, updateLocalUser } from '../actions';
import { api } from '../service/AppService';
import { getMallID } from '../util/serverUtil';

export function addUserPoint(action$, store) {
  return action$.ofType(ACTION_TYPE_ADD_POINT)
      .switchMap(action => {
          //console.log('addUserPoint epic');
        return api.addPoint(
            store.getState().userReducer.objectId,
            {
                pointType: action.payload.pointType,
                member_code: store.getState().userReducer.data[0]['vip_code'],
                social_point: action.payload.point,
                mall_id: getMallID(),//store.getState().userReducer.data[0]['mall_id'],
                remark:action.payload.remark
            },
            store.getState().loginReducer.sessionToken
            )
            // .map(res => pointResult(res.body.text))
            .mergeMap(res => {
                return Observable.merge(
                    Observable.of(pointResult(res.body.text)),
                    Observable.of(updateLocalUser(res.body.text)),
                );
            })

            .catch(error => {
                // Observable.of(waterError(error))
                return Observable.merge(
                    Observable.of(showRichModal({
                        title: 'Error ' + 'point_epic',
                        content: error.status + ' ' + error.toString(),
                    })),
                    Observable.of(pointError(error)),
                    Observable.of(epicCatchError(error, 'point_epic')))
            })
      });
}



// WEBPACK FOOTER //
// ./src/epics/point.js